module.exports = __webpack_public_path__ + "img/logo-im.8189bfd0.svg";